import React from 'react';
import ContactForm from '../components/ContactForm';

const AboutPage: React.FC = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="bg-snudefryd-beige py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Om os</h1>
          <p className="text-lg text-gray-700 max-w-3xl">
            Lær mere om Snudefryd og vores passion for at hjælpe hundeejere med at give deres hunde det bedste liv.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Text */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-snudefryd-blue">Vores historie</h2>
            <div className="prose max-w-none">
              <p className="mb-4">
                Snudefryd blev grundlagt med en simpel mission: at forbedre hundes sundhed gennem korrekt ernæring, og sikre et sundere og længere liv for vores firbenede venner.
                
              </p>
              <p className="mb-4">
                Efter flere års erfaring inden for veterinærverdenen, opdagede jeg, at mange hundeejere manglede viden om, hvordan de skulle sammensætte den optimale kost til deres hunde. Dette førte til etableringen af Snudefryd, hvor vi kombinerer videnskabelig viden med praktisk erfaring for at skabe skræddersyede ernæringsplaner.
              </p>
              <p className="mb-4">
              Jeg er uddannet veterinærreceptionist og hundetræner. Jeg har, derfor en bred viden og stor kærlighed til hunde. Jeg er nu i gang med en uddannelse som hundeernæringsrådgiver, for at kunne give endnu bedre vejledning. Jeg fortsætter med at udvide vores viden og services for at kunne hjælpe endnu flere.
              </p>
            </div>

            <h2 className="text-2xl font-bold mt-8 mb-6 text-snudefryd-blue">Vores mission</h2>
            <div className="prose max-w-none">
              <p className="mb-4">
                Hos Snudefryd tror vi på, at hver hund er unik og fortjener en ernæringsplan, der er skræddersyet til dens specifikke behov. Vores mission er at:
              </p>
              <ul className="list-disc pl-5 mb-4">
                <li>Oplyse hundeejere om vigtigheden af korrekt ernæring</li>
                <li>Tilbyde personlig rådgivning</li>
                <li>Hjælpe hunde med særlige behov gennem specialiserede kostplaner</li>
                <li>Dele vores viden gennem blog-indlæg</li>
                <li>Skabe et fællesskab af hundeejere, der prioriterer deres hundes sundhed</li>
              </ul>
            </div>
          </div>

          {/* Right Column - Image and Expert Info */}
          <div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8">
              <img
                src="/Erica.png"
                alt="Hundeernæringsrådgiver"
                className="w-full h-100 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2">Erica Torp & Agnes, staffordshire bullterrier</h3>
                <p className="text-gray-600 mb-4">Grundlægger & Hundeernæringsrådgiver</p>
                <p className="text-gray-700">
                Da jeg stod med min hunds allergi-diagnose i hånden, vidste jeg ikke, hvor jeg skulle starte. Jeg fandt ud af, at med korrekt ernæring, kunne jeg holde hendes allergi i skak. Hun er en stor inspiration til at Snudefryd blev til. Jeg savnede, et sted at søge viden om korrekt ernæring, og et fælleskab med andre ligesindede hundeejere.   
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-xl font-bold mb-4">Vores værdier</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-5 h-5 text-snudefryd-blue" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold">Videnskabelig tilgang</h4>
                    <p className="text-gray-600 text-sm">Vi baserer vores anbefalinger på solid videnskabelig forskning og evidens.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-5 h-5 text-snudefryd-blue" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold">Personlig tilgang</h4>
                    <p className="text-gray-600 text-sm">Vi anerkender, at hver hund er unik og har individuelle behov.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-5 h-5 text-snudefryd-blue" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold">Kontinuerlig læring</h4>
                    <p className="text-gray-600 text-sm">Vi holder os opdateret med den nyeste viden inden for hundeernæring.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <svg className="w-5 h-5 text-snudefryd-blue" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold">Empati og omsorg</h4>
                    <p className="text-gray-600 text-sm">Vi forstår det særlige bånd mellem hund og ejer og arbejder med respekt for dette.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Contact Form Section */}
        <div className="mt-16">
          <h2 className="text-2xl font-bold mb-6 text-snudefryd-blue text-center">Kontakt os</h2>
          <p className="text-center text-gray-700 max-w-2xl mx-auto mb-8">
            Har du spørgsmål om vores services, eller ønsker du at booke en konsultation? Udfyld formularen nedenfor, og vi vender tilbage til dig hurtigst muligt.
          </p>
          <div className="max-w-2xl mx-auto">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 